import { FC } from 'react';

const ModalClose: FC = () => {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Home" transform="translate(-620.000000, -308.000000)">
                    <g id="-mockplus-" transform="translate(484.000000, 296.000000)">
                        <g id="control/pulldow" transform="translate(136.000000, 12.000000)">
                            <rect id="Rectangle" fillOpacity="0" fill="#D8D8D8" x="0" y="0" width="16" height="16"></rect>
                            <path
                                d="M4.06752081,5 L11.9324792,5 C12.2086216,5 12.4324792,5.22385763 12.4324792,5.5 C12.4324792,5.61696825 12.3914711,5.7302347 12.3165898,5.8200922 L8.38411064,10.5390672 C8.2073286,10.7512057 7.89204625,10.7798677 7.6799078,10.6030857 C7.65667627,10.5837261 7.63524897,10.5622988 7.61588936,10.5390672 L3.68341017,5.8200922 C3.50662813,5.60795375 3.53529016,5.2926714 3.74742861,5.11588936 C3.83728611,5.04100811 3.95055255,5 4.06752081,5 Z"
                                id="Rectangle"
                                fillOpacity="0.34"
                                fill="#000000"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default ModalClose;
